// The Marina Bay street circuit, from its real outline.
//
// scripts/track/gen-track.py reads the circuit's GPS outline (the 4.94 km
// layout), runs it anticlockwise from the start line, and turns how sharply the
// road bends at each point into `curve` values for the pseudo-3D road:
// negative is a left-hander, positive a right-hander. Straights are drawn a
// little shorter than life and the tightest hairpins a little longer, so the lap
// lasts about a minute and a half and every corner can be driven.

import { RUNS, CORNERS } from './marina-bay.js';

export const SEGMENT_LENGTH = 200;

/** Every segment of the lap, in order: { index, curve, corner }. */
export function buildTrack() {
  const segments = [];
  for (const [length, curve] of RUNS) {
    for (let i = 0; i < length; i++) segments.push({ index: segments.length, curve, corner: null });
  }
  CORNERS.forEach(([first, last], n) => {
    for (let i = first; i <= last && i < segments.length; i++) segments[i].corner = `Turn ${n + 1}`;
  });
  return segments;
}

/** The next corner at or ahead of a segment, for the dashboard. */
export function nextCorner(segments, index) {
  for (let i = 0; i < segments.length; i++) {
    const s = segments[(index + i) % segments.length];
    if (s.corner) return s.corner;
  }
  return null;
}
